(() => {
  const hookSelector = '[data-hook-addon]';

  const getSelectedType = (root = document) => {
    const typeInput = root.querySelector('.variants-wrapper--kit .js-single-option-selector:checked');

    return typeInput ? typeInput.value : '';
  };

  const checkedAddons = (form) => {
    return [...form.querySelectorAll(hookSelector)].filter((input) => {
      return input.checked && !input.disabled && Number(input.dataset.variantId);
    });
  };

  const updateHookAddon = (root = document) => {
    const addon = root.querySelector('[data-sp-hook-addon]');

    if (!addon) return;

    const input = addon.querySelector(hookSelector);
    const includesHooks = getSelectedType(root) === 'Pro Set';

    addon.hidden = includesHooks;
    addon.classList.toggle('is-hidden', includesHooks);

    if (!input) return;

    input.disabled = includesHooks;

    if (includesHooks) {
      input.checked = false;
    }
  };

  const updateKitSpec = (root = document) => {
    const spec = root.querySelector('[data-sp-kit-spec-text]');

    if (!spec) return;

    const selectedType = getSelectedType(root);

    if (selectedType === 'Pro Set') {
      spec.textContent = 'Includes 3 BKK 8/0 Titan Divers';
      return;
    }

    spec.textContent = 'Use with BKK 8/0 Titan Diver';
  };

  const youtubeEmbedUrl = (videoId) => {
    const params = new URLSearchParams({
      autoplay: '1',
      rel: '0',
      modestbranding: '1',
      playsinline: '1'
    });

    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params.toString()}`;
  };

  const setActiveVideo = (section, thumb, { autoplay = false } = {}) => {
    const stage = section.querySelector('[data-sp-video-stage]');
    const poster = section.querySelector('[data-sp-video-play]');
    const frame = section.querySelector('[data-sp-video-frame]');
    const caption = section.querySelector('[data-sp-video-caption]');
    const videoId = thumb.dataset.videoId;
    const aspect = thumb.dataset.videoAspect || 'shorts';
    const posterImage = poster?.querySelector('img');

    section.querySelectorAll('[data-sp-video-thumb]').forEach((button) => {
      const isActive = button === thumb;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (stage) {
      stage.classList.toggle('is-shorts', aspect === 'shorts');
      stage.classList.toggle('is-wide', aspect === 'wide');
    }

    if (posterImage) {
      posterImage.src = `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
    }

    if (poster) {
      poster.setAttribute('aria-label', `Play ${thumb.dataset.videoTitle || 'video'}`);
      poster.hidden = autoplay;
    }

    if (caption) {
      const credit = document.createElement('span');
      credit.className = 'sp-field-videos__credit';
      credit.textContent = thumb.dataset.videoCredit || '';
      const nodes = [credit];

      if (thumb.dataset.videoUrl) {
        const link = document.createElement('a');
        link.className = 'sp-field-videos__watch-link';
        link.href = thumb.dataset.videoUrl;
        link.textContent = thumb.dataset.videoTitle || 'Watch';
        nodes.push(link);
      } else {
        nodes.push(document.createTextNode(thumb.dataset.videoTitle || ''));
      }

      caption.replaceChildren(...nodes);
    }

    if (typeof thumb.scrollIntoView === 'function' && window.matchMedia('(max-width: 991px)').matches) {
      thumb.scrollIntoView({
        inline: 'center',
        block: 'nearest',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    if (!frame) return;

    if (!autoplay) {
      frame.hidden = true;
      frame.innerHTML = '';
      return;
    }

    frame.hidden = false;
    frame.innerHTML = `<iframe src="${youtubeEmbedUrl(videoId)}" title="${thumb.dataset.videoTitle || 'Product video'}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
  };

  const playCurrentVideo = (section) => {
    const activeThumb = section.querySelector('[data-sp-video-thumb].is-active') || section.querySelector('[data-sp-video-thumb]');

    if (!activeThumb) return;

    setActiveVideo(section, activeThumb, { autoplay: true });
  };

  const stopVideoCard = (card) => {
    const poster = card.querySelector('[data-sp-video-play]');
    const frame = card.querySelector('[data-sp-video-frame]');

    if (poster) poster.hidden = false;

    if (!frame) return;

    frame.hidden = true;
    frame.innerHTML = '';
  };

  const playVideoCard = (card) => {
    const poster = card.querySelector('[data-sp-video-play]');
    const frame = card.querySelector('[data-sp-video-frame]');
    const videoId = card.dataset.videoId;

    if (!frame || !videoId) return;

    document.querySelectorAll('[data-sp-video-card]').forEach((otherCard) => {
      if (otherCard !== card) stopVideoCard(otherCard);
    });

    if (poster) poster.hidden = true;

    frame.hidden = false;
    frame.innerHTML = `<iframe src="${youtubeEmbedUrl(videoId)}" title="${card.dataset.videoTitle || 'Product video'}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
  };

  const initializeVideoCards = (root = document) => {
    root.querySelectorAll('[data-sp-video-card]').forEach((card) => {
      if (card.dataset.spVideosReady === 'true') return;

      card.dataset.spVideosReady = 'true';
      card.addEventListener('click', (event) => {
        if (!event.target.closest('[data-sp-video-play]')) return;

        playVideoCard(card);
      });
    });
  };

  const initializeVideos = (root = document) => {
    initializeVideoCards(root);

    root.querySelectorAll('[data-sp-field-videos]').forEach((section) => {
      if (section.dataset.spVideosReady === 'true') return;

      section.dataset.spVideosReady = 'true';

      const firstThumb = section.querySelector('[data-sp-video-thumb]');

      if (firstThumb) {
        setActiveVideo(section, firstThumb, { autoplay: false });
      }

      section.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-sp-video-thumb]');

        if (thumb) {
          setActiveVideo(section, thumb, { autoplay: true });
          return;
        }

        if (event.target.closest('[data-sp-video-play]')) {
          playCurrentVideo(section);
        }
      });
    });
  };

  const initializeKit = (root = document) => {
    updateHookAddon(root);
    updateKitSpec(root);
  };

  const handleOptionChange = (event) => {
    if (!event.target.closest?.('.js-single-option-selector')) return;

    initializeKit(document);
  };

  const addHookThenProduct = async (form) => {
    const addons = checkedAddons(form);

    if (!addons.length) return false;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: addons.map((input) => ({
          id: Number(input.dataset.variantId),
          quantity: 1
        }))
      })
    });

    if (!response.ok) {
      throw new Error('Could not add recommended accessories');
    }

    return true;
  };

  let hookSubmitLock = false;

  const handleFormSubmit = (event) => {
    const form = event.target;

    if (!form.matches?.('[data-product-form]')) return;

    if (!checkedAddons(form).length || hookSubmitLock) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    hookSubmitLock = true;

    addHookThenProduct(form)
      .catch(() => false)
      .finally(() => {
        form.requestSubmit();
        window.setTimeout(() => {
          hookSubmitLock = false;
        }, 400);
      });
  };

  const initialize = (root = document) => {
    initializeVideos(root);
    initializeKit(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('change', handleOptionChange);
  document.addEventListener('submit', handleFormSubmit, true);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
